import { Component, OnInit } from "@angular/core";
import { FieldArrayType } from "@ngx-formly/core";

@Component({
    selector: "formly-repeat-inline",
    template: `
        <div class="flex flex-row items-start gap-4">
            <div class="w-full flex flex-row items-center flex-wrap gap-4">
                <div
                    *ngFor="let field of field.fieldGroup; let i = index"
                    class="flex flex-row items-center gap-4 flex-grow over-tinted-bg"
                >
                    <div class="w-full">
                        <formly-field [field]="field"></formly-field>
                    </div>

                    <button mat-icon-button (click)="remove(i)">
                        <mat-icon [svgIcon]="'trash'"></mat-icon>
                    </button>
                </div>
            </div>

            <div class="flex flex-col items-center">
                <v2-button-wrapper
                    class="mt-4"
                    color="accent"
                    [text]="to.addText"
                    variant="flat"
                    (click)="add()"
                ></v2-button-wrapper>
                <div *ngIf="showError" class="text-red-500 text-sm mt-1">
                    <formly-validation-message [field]="field"></formly-validation-message>
                </div>
            </div>
        </div>
    `,
})
export class RepeatInlineTypeComponent extends FieldArrayType {
    ngOnInit() {
        this.updateLabels();
    }

    add() {
        super.add();
        setTimeout(() => this.updateLabels(), 0);
    }

    remove(i: number) {
        super.remove(i);
        this.formControl.markAsTouched();
        this.formControl.markAsDirty();
        this.formControl.updateValueAndValidity();
        setTimeout(() => this.updateLabels(), 0);
    }

    updateLabels() {
        this.field.fieldGroup.forEach((field, i) => {
            const doseDateField = field.fieldGroup.find((f) => f.key === "doseDate");

            if (doseDateField) {
                const newLabel = `${i + 1}ª dose`;

                doseDateField.templateOptions = {
                    ...doseDateField.templateOptions,
                    label: newLabel,
                };
            }
        });
    }
}
